/* eslint-disable no-unused-vars */
import React, { createContext, useState } from 'react';

export interface IAuthContext {
  username: string | null;
  password: string | null;
  mfaCode: string | null;

  setUser: (value: string) => void;
  setPass: (value: string) => void;
  setMfaCode: (value: string) => void;

  reset: (value: string) => void;
}

const useStore = () => {
  const [username, setUser] = useState<string | null>(null);
  const [password, setPass] = useState<string | null>(null);
  const [mfaCode, setMfaCode] = useState<string | null>(null);

  return {
    username,
    password,
    mfaCode,

    setUser: (value: string) => setUser(value),
    setPass: (value: string) => setPass(value),
    setMfaCode: (value: string) => setMfaCode(value),

    reset: () => {
      setUser(null);
      setPass(null);
      setMfaCode(null);
    },
  };
};

export const AuthContext = createContext<IAuthContext | null>(null);
interface StoreContextProviderProps {
  children: React.ReactNode;
}

export const StoreContextProvider: React.FC<StoreContextProviderProps> = ({ children }) => (
  <AuthContext.Provider value={useStore()}>{children}</AuthContext.Provider>
);
